import { render, staticRenderFns } from "./TaxonomyLevelsTree.vue?vue&type=template&id=a20d8886&scoped=true&"
import script from "./TaxonomyLevelsTree.vue?vue&type=script&lang=js&"
export * from "./TaxonomyLevelsTree.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyLevelsTree.vue?vue&type=style&index=0&id=a20d8886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20d8886",
  null
  
)

export default component.exports